import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { ChemicalAnchor } from "../../../../http/concreteResin/types/chemicalAnchors";
import useChemicalAnchorsApi from "../../../../http/concreteResin/useChemicalAnchors";
import ChemicalAnchorForm from "./ChemicalAnchorForm";

const AdminChemicalAnchors: FC = () => {
  const i18n = useI18n();
  const chemicalAnchorsApi = useChemicalAnchorsApi();

  return (
    <AdminCrudTable<ChemicalAnchor>
      filterPrefix="anchors"
      useList={chemicalAnchorsApi.useChemicalAnchors}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.description}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.concreteResinModule.mlQuantity}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item.code}</TableCell>
          <TableCell>{item.item.description}</TableCell>
          <TableCell>{item.mlQuantity}</TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          chemicalAnchorsApi.updateChemicalAnchorVisibility(item.id, { visibility }),
        updateOrder: (item, order) => chemicalAnchorsApi.updateChemicalAnchorOrder(item.id, { order }),
      }}
      onDelete={(item) => chemicalAnchorsApi.deleteChemicalAnchor(item.id)}
      deleteTitle={i18n.translation.concreteResinModule.chemicalAnchor}
      canAdd
      renderForm={(item, onClose) => <ChemicalAnchorForm chemicalAnchor={item} onClose={onClose} />}
    />
  );
};

export default AdminChemicalAnchors;
